module.exports = __webpack_public_path__ + "static/img/logo-ew.0234d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ew.png
// module id = zYkp
// module chunks = 1